// extracted by mini-css-extract-plugin
module.exports = {"ArticlePoster__Thumbnail":"gA4Eg","ArticlePoster__Body":"_8wgR7","ArticlePoster__Label":"Jm7H0","ArticlePoster__Title":"zn6w2","ArticlePoster__Social":"g15Wg"};